<template>
    <div class="related-data">
        <a-modal class="related-modal" :centered='true' :maskClosable='false' v-model.trim="relatedDataBool"  footer='' width='980px' :closable='false'>
            <div style="height:55px;line-height:55px;">
                <span style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;padding-left:24px;">关联数据</span>
                <a-icon @click="cancelSelectRelatedData" type="close" style="color:rgba(158, 172, 196, 1);font-size:18px;float:right;margin:20px 20px 0 0;cursor:pointer;" />
            </div>
            <div style="border-top:1px solid rgba(229, 229, 229, 1);border-bottom:1px solid rgba(229, 229, 229, 1);display:flex;overflow-y:auto;">
                <div style="width:160px;border-right:1px solid rgba(229, 229, 229, 1);padding:16px;max-height:370px;overflow-y:auto;">
                    <a-tree :tree-data="treeData" default-expand-all @select="onSelect">
                        
                    </a-tree>
                </div>
                <div style="flex:1;padding: 0 0 20px 0;min-height:350px;max-height:480px;overflow-y:auto;">
                    <div>
                        <a-input @keyup.enter="inputQueryData" v-model="searchContent" placeholder="搜索标题（按Enter键搜索）" />
                    </div>
                    <div class="data-box">
                        <div class="data-list" @click="chooseDataItem(index, item)" :class="{'active':item.selected}" v-for="(item,index) in dataList" :key='index'>
                            <span class="data-title">{{item.dataTitle}}</span>
                            <div class="right-info">
                                <span class="data-date">{{item.createTime}}</span>
                                <span v-if="item.owner!=null" class="data-name">{{item.owner!=null?item.owner.substr(-2,2):''}}</span>
                                <span v-if="item.owner==null" style="display:inline-block;width:28px;height:28px;"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height:59px;padding:16px 20px 0 0">
                <div style="float:right">
                    <a-button @click="cancelSelectRelatedData" style="height:28px;line-height:28px;border:none;margin-right:8px;font-size:13px;color:rgba(158, 172, 196, 1)">取消</a-button>
                    <a-button @click="sureSelectRelatedData" type="primary" style="height:28px;line-height:28px;border:none;font-size:13px;">
                        确定
                    </a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    props:{
        // currentFieldId: {
        //     default: ''
        // },
    },
    data(){
        return{
            relatedDataBool: false, 
            treeData: [],
            dataList: [],
            value: '',
            searchContent: '',
            moduleId: ''
        }
    },
    methods: {
        changeRelatedDataBoolValue() {
            this.relatedDataBool = true
        },
        cancelSelectRelatedData() {
            this.relatedDataBool = false
        },
        sureSelectRelatedData() {
            this.relatedDataBool = false
            this.$parent.fieldInputBlur(this.$parent.currentFieldId, this.value)
        },
        chooseDataItem(index, item) {
            for(let i = 0; i < this.dataList.length; i++){
                this.dataList[i]['selected'] = false
            }
            this.dataList[index]['selected'] = true
            this.value = item.id
        },
        queryMenuList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/module/associatedMenuList', 
                    params: {
                        fieldId: this.$parent.currentFieldId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.treeData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onSelect(selectedKeys) {
            let str = selectedKeys[0]
            let moduleId = str.split("-")[1]
            this.dataList = []
            this.value = ''
            if(moduleId!=undefined){
                this.queryAssociatedModuleData(moduleId)
                this.moduleId = moduleId
            }
        },
        inputQueryData() {
            if(this.moduleId != ''){
                this.queryAssociatedModuleData(this.moduleId)
            }
        },
        queryAssociatedModuleData(id) {
            this.axios(
                {
                    method:'get',
                    url:'/api/module/associatedModule/data/list', 
                    params: {
                        currentModuleId: this.$parent.moduleId,
                        currentDataId: this.$parent.dataId,
                        fieldId: this.$parent.currentFieldId,
                        associatedModuleId: id,
                        param: this.searchContent
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    let arr = response.data.data, brr = []
                    for(let i = 0; i < arr.length; i++){
                        let obj = {}
                        obj.selected = false
                        obj.createTime = arr[i]['createTime']
                        obj.dataTitle = arr[i]['dataTitle']
                        obj.id = arr[i]['id']
                        obj.owner = arr[i]['owner']
                        brr.push(obj)
                    }
                    this.dataList = brr
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        }
    },
    mounted: function() {
        
    }
}
</script>
<style scoped lang="less">
    .related-modal{
        .data-box{
            max-height: 450px;
            overflow-y: auto;
            // padding: 24px;
            .data-list{
                height: 55px;
                padding: 13px 24px 0;
                cursor: pointer;
                .data-title{
                    color: rgba(18, 18, 18, 1);;
                    font-size: 13px;
                }
                .right-info{
                    float: right;
                    display: inline-block;
                    .data-date{
                        color: rgba(158, 172, 196, 1);
                        font-size: 13px;
                        margin-right: 20px;
                    }
                    .data-name{
                        display: inline-block;
                        width: 28px;
                        height: 28px;
                        text-align: center;
                        line-height: 28px;
                        border-radius: 14px;
                        color: #fff;
                        background: rgba(35, 218, 119, 1);
                        font-size: 12px;
                    }
                }
            }
            .data-list:hover{
                background: rgba(240, 242, 243, 0.5);
            }
            .active{
                background: #3ADCFF !important;
                color: #fff;
            }
        }
    }
</style>